<!-- notifications-page.component.html -->
<div class="">

  <!-- ── Page header ──────────────────────────────────── -->
  <div class="np-header">
    <div class="np-header__left">
      <h1 class="np-title">
        <mat-icon class="np-title__icon">notifications</mat-icon>
        Notifications
      </h1>
      @if (totalCount > 0) {
        <span class="np-total-badge">{{ totalCount }}</span>
      }
    </div>

    <div class="np-header__right">
      @if (unreadCount > 0) {
        <button class="np-mark-all-btn" (click)="onMarkAllRead()" mat-stroked-button>
          <mat-icon>done_all</mat-icon>
          Mark all as read
        </button>
      }
    </div>
  </div>

  <!-- ── Filter tabs ──────────────────────────────────── -->
  <div class="np-tabs" role="tablist">
<button
  class="np-tab"
  [class.np-tab--active]="activeTab === 'all'"
  (click)="setTab('all')"
  role="tab"
  [attr.aria-selected]="activeTab === 'all'"
>
  All
  <span class="np-tab__count">{{ allCount }}</span>
</button>
    <button
      class="np-tab"
      [class.np-tab--active]="activeTab === 'unread'"
      (click)="setTab('unread')"
      role="tab"
      [attr.aria-selected]="activeTab === 'unread'"
    >
      Unread
      @if (unreadCount > 0) {
        <span class="np-tab__count np-tab__count--red">{{ unreadCount }}</span>
      }
    </button>
  </div>

  <div class="np-divider"></div>

  <!-- ── Loading state ────────────────────────────────── -->
  @if (isLoading) {
    <div class="np-skeleton-list">
      @for (i of [1,2,3,4,5]; track i) {
        <div class="np-skeleton-item">
          <div class="np-skel-icon"></div>
          <div class="np-skel-content">
            <div class="np-skel-line np-skel-line--title"></div>
            <div class="np-skel-line np-skel-line--msg"></div>
            <div class="np-skel-line np-skel-line--meta"></div>
          </div>
          <div class="np-skel-tag"></div>
        </div>
      }
    </div>
  }

  <!-- ── Empty state ──────────────────────────────────── -->
  @if (!isLoading && filtered.length === 0) {
    <div class="np-empty">
      <div class="np-empty__circle">
        <mat-icon>notifications_none</mat-icon>
      </div>
      @if (activeTab === 'unread') {
        <h2 class="np-empty__title">All caught up!</h2>
        <p class="np-empty__sub">You have no unread notifications</p>
      } @else {
        <h2 class="np-empty__title">No notifications yet</h2>
        <p class="np-empty__sub">When something happens, you'll see it here</p>
      }
    </div>
  }

  <!-- ── Notification list ─────────────────────────────── -->
  @if (!isLoading && filtered.length > 0) {
    <ul class="np-list" role="list">
      @for (notif of filtered; track trackById($index, notif)) {
     <li
  class="np-item"
  [class.np-item--unread]="!notif.isRead"
  role="listitem"
  (click)="onNotifClick(notif)"
  [class.np-item--clickable]="notif.triggeredByResourceType === 'Event'"
>
          <!-- Color bar -->
          <span class="np-item__bar" [attr.data-color]="getNotifColor(notif.type)"></span>

          <!-- Icon -->
          <div class="np-item__icon" [attr.data-color]="getNotifColor(notif.type)">
            <mat-icon>{{ getNotifIcon(notif.type) }}</mat-icon>
          </div>

          <!-- Content -->
          <div class="np-item__content">
            <div class="np-item__header">
              <span class="np-item__title">{{ notif.title }}</span>
              <span class="np-item__type-chip" [attr.data-color]="getNotifColor(notif.type)">
                {{ getTypeLabel(notif.type) }}
              </span>
            </div>
            <p class="np-item__message">{{ notif.message }}</p>
            <div class="np-item__meta">
              <mat-icon class="meta-icon">schedule</mat-icon>
              <span class="meta-time" [title]="formatFullDate(notif.createdAt)">
                {{ formatTime(notif.createdAt) }}
              </span>
              @if (notif.isRead && notif.readAt) {
                <span class="meta-sep">·</span>
                <mat-icon class="meta-icon meta-icon--read">visibility</mat-icon>
                <span class="meta-read">Read {{ formatTime(notif.readAt) }}</span>
              }
            </div>
          </div>

          <!-- Right side actions -->
          <div class="np-item__actions">
            @if (!notif.isRead) {
              <span class="np-unread-dot"></span>
            }
            <button
              class="np-delete-btn"
              (click)="onDelete($event, notif.id)"
              type="button"
              mat-icon-button
              title="Dismiss"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </li>
      }
    </ul>

    <!-- Load more -->
    @if (hasMore && activeTab === 'all') {
      <div class="np-load-more">
        <button
          class="np-load-more-btn"
          (click)="loadMore()"
          [disabled]="isLoadingMore"
          mat-stroked-button
        >
          @if (isLoadingMore) {
            <mat-spinner diameter="16"></mat-spinner>
          } @else {
            <mat-icon>expand_more</mat-icon>
          }
          {{ isLoadingMore ? 'Loading...' : 'Load more' }}
        </button>
      </div>
    }
  }

</div>
